export enum FeatureFlag {
    TEARSHEETEXCLUSION = 'TearsheetExclusion',
    TEARSHEETPACKAGE = 'TearsheetPackage',
    DASHBOARD = 'Dashboard',
    REVIEWLOCKING = 'ReviewLocking',
    SUMMARYLOCKING = 'SummaryLocking',
    FUNDCAPMEMMANAGE = 'FundCapMemManage',
    VALUATIONLOCKING = 'ValuationLocking',
    METRICTOOLTIP = 'MetricToolTip',
    COMMITMENTSAPPROVE = 'CommitmentsApprove',
    QDSNOTIFICATIONTRAY = 'QdsNotificationTray',
    NOTIFICATIONS = 'Notifications',
    TEARSHEETEDITDOWNLOAD = 'tearsheetdownload',
    REPORTS = 'Reports',
    UPLOADEXTERNALPDF = 'UploadExternalPdf',
    DASHBOARDPORTFOLIOREPORTS = 'DashboardPortfolioReport',
    PCANALYTICS = 'PcAnalytics'
}
  